import { ResponsiveContainer, LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, PieChart, Pie, Cell } from 'recharts';

const COLORS = ['#c2410c', '#0369a1', '#15803d', '#a16207', '#7c3aed', '#db2777'];
const CHART_TICK = { fontSize: 12, fill: '#78716c' };
const TOOLTIP_STYLE = { borderRadius: '8px', border: '1px solid #e7e5e4' };
const LINE_DOT = { fill: '#c2410c', strokeWidth: 2 };

export const RevenueChart = ({ data, formatCurrency }) => (
  <div className="lg:col-span-2 bg-white border border-stone-200 rounded-md p-6">
    <h3 className="font-semibold text-stone-900 font-['Manrope'] mb-4">Revenue Trend</h3>
    {data?.revenue_by_date?.length > 0 ? (
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data.revenue_by_date}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e7e5e4" />
          <XAxis dataKey="date" tick={CHART_TICK} tickFormatter={(value) => value.slice(5)} />
          <YAxis tick={CHART_TICK} tickFormatter={(value) => `₹${value}`} />
          <Tooltip formatter={(value) => [formatCurrency(value), 'Revenue']} contentStyle={TOOLTIP_STYLE} />
          <Line type="monotone" dataKey="amount" stroke="#c2410c" strokeWidth={2} dot={LINE_DOT} />
        </LineChart>
      </ResponsiveContainer>
    ) : (
      <div className="flex items-center justify-center h-[300px] text-stone-500">No revenue data available</div>
    )}
  </div>
);

export const BookingStatusChart = ({ data, formatCurrency }) => {
  const bookingStatusData = data?.bookings ? [
    { name: 'Completed', value: data.bookings.completed },
    { name: 'Cancelled', value: data.bookings.cancelled },
    { name: 'Active', value: data.bookings.total - data.bookings.completed - data.bookings.cancelled }
  ].filter(d => d.value > 0) : [];

  return (
    <div className="bg-white border border-stone-200 rounded-md p-6">
      <h3 className="font-semibold text-stone-900 font-['Manrope'] mb-4">Booking Status</h3>
      {bookingStatusData.length > 0 ? (
        <ResponsiveContainer width="100%" height={200}>
          <PieChart>
            <Pie data={bookingStatusData} cx="50%" cy="50%" innerRadius={50} outerRadius={80} paddingAngle={2} dataKey="value">
              {bookingStatusData.map((entry, index) => (<Cell key={`cell-${entry.name}`} fill={COLORS[index % COLORS.length]} />))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      ) : (
        <div className="flex items-center justify-center h-[200px] text-stone-500">No booking data</div>
      )}
      <div className="mt-4 space-y-2">
        {bookingStatusData.map((item, index) => (
          <div key={item.name} className="flex items-center justify-between text-sm">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded" style={{ backgroundColor: COLORS[index] }}></div>
              <span className="text-stone-600">{item.name}</span>
            </div>
            <span className="font-medium text-stone-900">{item.value}</span>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-stone-100">
        <div className="flex items-center justify-between">
          <span className="text-stone-600">Completion Rate</span>
          <span className="font-bold text-emerald-700">{data?.bookings?.completion_rate || 0}%</span>
        </div>
        <div className="flex items-center justify-between mt-2">
          <span className="text-stone-600">Avg. Booking Value</span>
          <span className="font-bold text-sage-700">{formatCurrency(data?.average_booking_value || 0)}</span>
        </div>
      </div>
    </div>
  );
};
